// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons/buttons';
import { Timeline, TimelineItem } from 'components/widgets/timeline';
import Email from 'components/models/email/email';
import SVG from 'components/widgets/icons/svg';
import Ticket from 'services/data/ticket';

// Component
class TicketTasks extends React.Component {
  static propTypes = {
    emails: PropTypes.array,
    ticket: PropTypes.object,
    currentUser: PropTypes.object,
    teams: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.state = { showAllEmails: false };
  }

  render() {
    const { emails, ticket, currentUser, teams } = this.props;
    const { showAllEmails } = this.state;

    if (!ticket || _.isEmpty(ticket)) return null;

    const sortedEmails = _.orderBy(emails, [email => moment(email.createdAt).toDate()], ['desc']);
    const ticketTeamCC = `${Ticket.getTicketCC(ticket)},${Ticket.getTeamEmails(ticket, currentUser, teams)}`;
    const mailtoLink = Ticket.getMailtoLink(ticket, ticketTeamCC);
    const maxEmails = 20;
    const limitEmails = sortedEmails.length > maxEmails && !showAllEmails;
    const visibleEmails = limitEmails ? _.take(sortedEmails, maxEmails) : sortedEmails;

    return (
      <PageContent className="ticket">
        <div className="ticket-emails">
          <div className="flex offset-page-padding p-0">
            <a href={mailtoLink} target="_blank" className="full-page-add-link page-padding flex-fill btn-success">
              <div>
                <SVG src="svg/add.svg" className="add mr-2" />
                <span>Send New Email</span>
              </div>
              <SVG src="svg/email.svg" />
            </a>
            <a href={Ticket.getGmailSearchLink(ticket)} target="_blank" className="full-page-add-link page-padding flex-fill btn-secondary">
              <div>
                <SVG src="svg/search.svg" className="add mr-2" />
                <span>Search Gmail</span>
              </div>
              <SVG src="svg/email.svg" />
            </a>
          </div>
          {(emails && !!emails.length) &&
            <div className="email-timeline">
              <Timeline>
                {_.map(visibleEmails, email =>
                  <TimelineItem key={email.id} user={email.fromPerson} date={email.createdAt}>
                    <Email email={email} />
                  </TimelineItem>
                )}

                {limitEmails &&
                  <TimelineItem>
                    <h4>{sortedEmails.length - maxEmails} more emails hidden</h4>
                    <PrimaryButton onClick={() => this.setState({ showAllEmails: true })}>Show All</PrimaryButton>
                  </TimelineItem>
                }
              </Timeline>
            </div>
          }
        </div>
      </PageContent>
    );
  }
}

// Exports
export default connect((state) => ({
  emails: state.tickets.emails,
  ticket: state.tickets.ticket,
  teams: state.pageData.teams,
  currentUser: state.auth.currentUser
}))(TicketTasks);



// WEBPACK FOOTER //
// ./app/routes/ticket/sub-routes/ticket-emails.js